import React, { useContext, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import avatar from "../../assets/images/avatar.svg";
import { Formik, Form } from "formik";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import { ProfileSection } from "../../context/ProfileContext";
import {
  profileUpdateApi,
  profileImageUpdateApi,
  logoutAllApi,
} from "../../api";
import { updateProfileInfo } from "../../redux";
import { Alert } from "../";
import { useTranslation } from "react-i18next";

const EditProfileComp = (props) => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.userProfileInfo);
  let form = useRef();
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const initialValues = {
    name: userInfo.name,
    phone: userInfo.phone,
  };

  const submitUpdateForm = (val) => {
    const data = new FormData(form.current);
    profileUpdateApi(data, token)
      .then(() => {
        ProfileShowHideFunc("firstPage");
        dispatch(updateProfileInfo({ name: val.name, phone: val.phone }));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const logoutAll = () => {
    logoutAllApi(token)
      .then((res) => {
        Cookies.remove("token");
        props.history.push("/login");
      })
      .catch((err) => console.log(err));
  };

  const { ProfileShowHideFunc } = useContext(ProfileSection);

  const imageSelected = (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];

      const data = new FormData();
      data.append("image", img);
      profileImageUpdateApi(data, token)
        .then((res) => {
          dispatch(updateProfileInfo({ image: res.data.data }));

          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("عکس آپلود شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        })
        .catch((err) => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("اندازه فایل مجاز نیست و یا نامعتبرست!"),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    }
  };

  return (
    <>
      <div className="d-flex flex-column align-items-center mb-3">
        <div className="position-relative mb-3">
          <div className="editProfileImg rounded-circle d-flex justify-content-center align-items-center">
            <img
              src={
                userInfo.image !== ""
                  ? "https://assessn.mmaviot.com" + userInfo.image
                  : avatar
              }
              width="75"
              height="75"
              className="rounded-circle"
            />
          </div>
          <label
            className="position-absolute m-0"
            style={{ bottom: "-9px", right: "30px" }}
          >
            <input
              type="file"
              className="d-none"
              onChange={(e) => imageSelected(e)}
            />
            <span className="d-block imgUpload rounded-circle d-flex justify-content-center align-items-center">
              <i className="icon-camera text-white"></i>
            </span>
          </label>
        </div>
        <p className="my-1 fn">{userInfo.name}</p>
        <p className="fn12">{userInfo.email}</p>
      </div>
      <Formik initialValues={initialValues} onSubmit={submitUpdateForm}>
        {(props) => (
          <Form ref={form}>
            <div style={{ height: "47vh" }}>
              <div className="editInputs d-flex flex-column justify-content-center m-auto px-3 pb-2 pt-4">
                <p className="fn12 m-0 text-right">{t("نام کاربری")}</p>
                <input
                  type="text"
                  placeholder={t("نام کاربری")}
                  defaultValue={props.values.name}
                  name="name"
                  className="w-100 fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <div className="editInputs d-flex flex-column justify-content-center m-auto px-3 py-2">
                <p className="fn12 m-0 text-right">{t("موبایل")}</p>
                <input
                  type="number"
                  placeholder={t("موبایل")}
                  defaultValue={props.values.phone}
                  name="phone"
                  className="w-100 fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <div className="editInputs d-flex flex-column justify-content-center m-auto px-3 py-2">
                <p className="fn12 m-0 text-right">{t("ایمیل")}</p>
                <input
                  type="email"
                  placeholder={t("ایمیل")}
                  disabled
                  defaultValue={userInfo.email}
                  className="w-100 fn12"
                />
              </div>
              <div
                onClick={logoutAll}
                className="bg-white text-right fn12 m-auto py-4 px-3 cursor"
                style={{ width: "90%", color: "#FF3900" }}
              >
                <a>{t("خروج از تمام حساب های کاربری")}</a>
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center">
              <button
                type="submit"
                className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              >
                <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                <small className="fn12 mt-1">{t("ذخیره")}</small>
              </button>
              <div
                className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                onClick={() => ProfileShowHideFunc("firstPage")}
              >
                <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                <small className="fn12 mt-1">{t("بازگشت")}</small>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

const EditProfile = withRouter(EditProfileComp);

export { EditProfile };
